import React, { useMemo, useState } from 'react';
import {useNavigate} from 'react-router-dom';
import pluswhite from "assets/images/icon/plus-white.png";
import checkorange from "assets/images/icon/icon-check-orange.png";
import filtersearch from "assets/images/icon/filter-search.png";
import AddTimekeepingSettingModal from 'pages/AddTimekeepingSettingModal';
import Input from 'components/Input';
import { timeKeepingColumns } from './columns';
import Table from 'components/Table';

const data = [
    {
        status: "Approve",
        shift_day: "Morning",
        workplace: "Main Office",
        clockin: "",
        clockout: "",
        total_hours: 24,
        paid_hours: 24,
        paid_breaks: 1,
        unpaid_breaks: 0,
    },
    {
        status: "Approve",
        shift_day: "Morning",
        workplace: "Main Office",
        clockin: "",
        clockout: "",
        total_hours: 24,
        paid_hours: 24,
        paid_breaks: 1,
        unpaid_breaks: 0,
    }
]

function TimeKeeping() {

    const navigate = useNavigate();
    const [settingModalOpen, setSettingModalOpen] = useState(false);

    const columns = useMemo(()=> {
        return timeKeepingColumns()
    }, [])

    return (
        <div className='content' style={{ padding: "16px 24px 16px 16px" }}>
            <div className='payroll-section'>
                {/* <div className='breadcrumb-section pb-3 border-bottom'>
                    <h2 className='main-title mb-1'>Payroll</h2>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="home">Home</a></li>
                            <li className="breadcrumb-item"><a href="dashboard">Dashboard</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Timekeeping</li>
                        </ol>
                    </nav>
                </div> */}
                <div className='payroll-details-section mt-3'>
                    <h2 className='main-title'>Time & Attendance</h2>
                    <div className='border-gray payroll-details p-4 mt-2'>
                        <div className='d-flex align-items-center justify-content-between border-bottom mb-4 pb-4'>
                            <div>
                                <h3 className='sub-title mb-3'>Timecard Options</h3>
                                <form>
                                    <div className="search-input">
                                        <input type='text' className='input-search' placeholder='Search Employees'/>
                                        <img className="search-icon" src={filtersearch} alt="filtersearch" />
                                    </div>
                                </form>
                            </div>
                            <div>
                                <button className='button-orange rounded-pill w-100 d-flex justify-content-center align-items-center gap-2' onClick={() => setSettingModalOpen(true)}>
                                    <img src={pluswhite} alt="pluswhite" />
                                    Add Timekeeping Setting</button>
                                <h3 className='sub-title timekeeping-title mt-3'>Timekeeping Code: wHz5m9wQ</h3>
                            </div>
                        </div>

                        <div>
                            <h2 className='sub-title'>Timecard Period Options</h2>
                            <form action="">
                                <div className="row mt-4 pay-schedules-section">

                                    <div className="col-lg-8">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <label>Pay Schedules</label>
                                                <div className="search-input">
                                                    {/* <input type='text' className='w-100' placeholder='Search Pay Schedules'/> */}
                                                    <Input variant='flat' fullWidth placeholder='Search Pay Schedules' />
                                                    <img className="search-icon" src={filtersearch} alt="filtersearch" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <label>Pay Days</label>
                                                <select className='w-100'>
                                                    <option>Select Status</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-6 mt-3">
                                                <label>Period Start</label>
                                                {/* <input className='w-100' type={"date"}/> */}
                                                <Input variant='flat' fullWidth type='date' />
                                            </div>
                                            <div className="col-lg-6 mt-3">
                                                <label>Period End</label>
                                                {/* <input className='w-100' type={"date"}/> */}
                                                <Input variant='flat' fullWidth type='date' />
                                            </div>
                                            <div className='mt-4'>
                                                <button className='button-orange'>Search</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className='mt-4'>
                    <div className='d-flex align-items-center gap-3'>
                        <button className='button-orange py-2 rounded-pill d-flex justify-content-center align-items-center gap-2' onClick={() => navigate('/dashboard/payroll-time-keeping/add-time-card')}>
                            <img src={pluswhite} alt="pluswhite" />
                            Add Timecard</button>
                        <button className='lite-orange-button py-2 rounded-pill d-flex justify-content-center align-items-center gap-2'>
                            <img src={checkorange} alt="checkorange" />
                            Approved</button>
                    </div>


                    {/* <div className='border-gray rounded-3 p-3 mt-3'>
                        <table className="table">
                            <thead>
                            <tr>
                                <th></th>
                                <th scope="col">Status</th>
                                <th scope="col">Shift Day</th>
                                <th scope="col">Workplace
                                </th>
                                <th scope="col">Clock-in
                                </th>
                                <th scope="col">Clock-out</th>
                                <th scope="col">Total Hours</th>
                                <th scope="col">Paid Hours</th>
                                <th scope="col">Paid Breaks</th>
                                <th scope="col">Unpaid Breaks</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr className='ping-bg'>
                                <td>
                                    <input type={'checkbox'}/>
                                </td>
                                <td>Approve</td>
                                <td>Morning</td>
                                <td>Main Office</td>
                                <td>12:00Am, <br/> 13 Feb, 25</td>
                                <td>12:00Am,<br/> 13 Feb, 25</td>
                                <td>24</td>
                                <td>24</td>
                                <td>1</td>
                                <td>0</td>
                            </tr>
                            <tr className='ping-bg'>
                                <td>
                                    <input type={'checkbox'}/>
                                </td>
                                <td>Approve</td>
                                <td>Morning</td>
                                <td>Main Office</td>
                                <td>12:00Am, <br/> 13 Feb, 25</td>
                                <td>12:00Am,<br/> 13 Feb, 25</td>
                                <td>24</td>
                                <td>24</td>
                                <td>1</td>
                                <td>0</td>
                            </tr>
                            </tbody>
                        </table>
                    </div> */}
                    <Table
                        headers={columns}
                        data={data}
                        showPagination={false}
                        containerClassName="mt-3"
                    />
                </div>
            </div>
            {settingModalOpen && <AddTimekeepingSettingModal show={settingModalOpen} setShow={setSettingModalOpen} />}
        </div>
    );
}


export default TimeKeeping;
